import { render, staticRenderFns } from "./client.vue?vue&type=template&id=21c7aac2&scoped=true"
import script from "./client.vue?vue&type=script&lang=js"
export * from "./client.vue?vue&type=script&lang=js"
import style0 from "./client.vue?vue&type=style&index=0&id=21c7aac2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7aac2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c7aac2')) {
      api.createRecord('21c7aac2', component.options)
    } else {
      api.reload('21c7aac2', component.options)
    }
    module.hot.accept("./client.vue?vue&type=template&id=21c7aac2&scoped=true", function () {
      api.rerender('21c7aac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/client.vue"
export default component.exports